import axios from '@/axios';

export default {
  getStaffs(_context, orgId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v1/organization/${orgId}/users`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeStaffs(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/v1/organization/${data.organizationId}/removeStaff/${data.userId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getPatients(_context, data) {
    let path = '/api/v1/organization/' + data.id + '/patients';
    return new Promise((resolve, reject) => {
      axios
        .get(path, {
          params: {
            page: data.page,
            limit: data.limit,
            search: data.search,
            clinic: data.clinic,
            clinicId: data.clinicId,
            userType: data.userType,
            sort: data.sort,
            productId: data.productId || '',
          },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  exportPatients(_context, data) {
    let path = '/api/v1/analytics/export-patients';
    
    return new Promise((resolve, reject) => {
        axios
        .get(path, { params: data })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
